import './style/TextArea.css';
import React from 'react';

const TextArea = ({ placeholder, type = "text", width100 = false, value, onChange, inputRef, flex, large = false, onBrand, onWhite = true, alignRight = false, onFocus = null, onBlur = null }) => {
    return (
        <textarea type={type} className={"keystone-text-area sf-mono size-m" + (flex ? " flex-1" : "") + (alignRight ? " align-right" : "") + (large ? " large" : " small") + (onBrand ? " on-brand" : "") + (onWhite ? " on-white" : "") + (width100 ? " width-100" : "")} placeholder={placeholder} onChange={onChange} onFocus={onFocus} onBlur={onBlur} value={value} ref={inputRef}>
        </textarea>
    );
};

export default React.memo(TextArea);